import * as types from '../actionType'

const initialState = []

const sellerOrderRefund = (state = initialState, action) => {
    switch (action.type) {
        case types.SELLER_POST_REFUND_ORDER:
            return action.payload
        default:
            return state
    }
}


export { sellerOrderRefund }